import React, { type FC } from 'react'

const UploadCvIcon: FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M31.9999 59.7333C47.2816 59.7333 59.7333 47.2984 59.7333 32.0257C59.6818 16.7015 47.2816 4.2666 31.9999 4.2666C16.6669 4.2666 4.2666 16.7015 4.2666 31.9741C4.2666 47.2984 16.6669 59.7333 31.9999 59.7333Z"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeWidth="0.533333"
            strokeMiterlimit="10"
        />
        <path
            d="M51.3811 20.5143V53.6494C51.3811 56.0638 49.4663 57.9786 47.0519 57.9786H17.2469C14.8326 57.9786 12.9177 56.0638 12.9177 53.6494V10.274C12.9177 7.85967 14.8326 5.94482 17.2469 5.94482H36.8949C37.9772 5.94482 38.9762 6.36109 39.7255 7.11038L50.2155 17.6004C50.9648 18.4329 51.3811 19.432 51.3811 20.5143Z"
            fill="white"
            stroke="#C3C3C3"
            strokeWidth="0.533333"
            strokeMiterlimit="10"
        />
        <path d="M38.6091 6.11035V15.9564C38.6091 17.7221 40.1044 19.1347 41.8035 19.1347H51.3306" fill="#C3C3C3" />
        <path
            d="M25.7788 48.9552H18.8362C18.5771 48.9552 18.3699 48.6799 18.3699 48.3494C18.3699 48.019 18.5771 47.7437 18.8362 47.7437H25.7788C26.0378 47.7437 26.2451 48.019 26.2451 48.3494C26.2451 48.7349 26.0378 48.9552 25.7788 48.9552Z"
            fill="#D0D0D0"
        />
        <path
            d="M34.6575 15.0314H19.0442C18.6811 15.0314 18.3699 14.7518 18.3699 14.4256C18.3699 14.0994 18.6811 13.8198 19.0442 13.8198H34.6575C35.0206 13.8198 35.3318 14.0994 35.3318 14.4256C35.3318 14.7518 35.0206 15.0314 34.6575 15.0314Z"
            fill="#C3C3C3"
        />
        <path
            d="M25.0206 18.6662H19.0401C18.6792 18.6662 18.3699 18.3866 18.3699 18.0604C18.3699 17.7342 18.6792 17.4546 19.0401 17.4546H24.969C25.3299 17.4546 25.6393 17.7342 25.6393 18.0604C25.6393 18.3866 25.3299 18.6662 25.0206 18.6662Z"
            fill="#C3C3C3"
        />
        <path
            d="M45.7464 39.8687H27.5403H25.5337H19.465C19.2203 39.8687 18.9756 40.1211 18.9756 40.4744C18.9756 40.7773 19.1714 41.0802 19.465 41.0802H25.5337H27.5403H45.7464C45.9911 41.0802 46.2358 40.8278 46.2358 40.4744C46.1869 40.1211 45.9911 39.8687 45.7464 39.8687Z"
            fill="#C3C3C3"
        />
        <path
            d="M45.7455 35.6279H38.9795H36.6751H19.4659C19.2207 35.6279 18.9756 35.8803 18.9756 36.2337C18.9756 36.5366 19.1717 36.8395 19.4659 36.8395H36.6751H38.9795H45.7455C45.9907 36.8395 46.2358 36.5871 46.2358 36.2337C46.1868 35.8803 45.9907 35.6279 45.7455 35.6279Z"
            fill="#C3C3C3"
        />
        <path
            d="M45.7899 31.3877H44.0316H42.2733H19.464C19.2198 31.3877 18.9756 31.6401 18.9756 31.9935C18.9756 32.2964 19.171 32.5993 19.464 32.5993H42.2733H44.227H45.7411C45.9853 32.5993 46.2295 32.3469 46.2295 31.9935C46.2784 31.6906 46.0342 31.3877 45.7899 31.3877Z"
            fill="#C3C3C3"
        />
        <path
            d="M45.7516 27.147H40.0865H38.6824H19.4598C19.2177 27.147 18.9756 27.3994 18.9756 27.7528C18.9756 28.0556 19.1693 28.3585 19.4598 28.3585H38.6824H40.0865H45.7032C46.0421 28.3585 46.2358 28.1061 46.2358 27.7528C46.2358 27.4499 46.0421 27.147 45.7516 27.147Z"
            fill="#C3C3C3"
        />
        <path
            d="M59.5061 51.6667C59.2991 52.5439 58.9885 53.4727 58.6262 54.2467C57.6426 56.1559 56.0897 57.6524 54.1745 58.6328C52.2074 59.6132 49.878 60.026 47.5487 59.51C42.0617 58.3748 38.5417 53.0083 39.6805 47.5386C40.8193 42.0689 46.151 38.5084 51.638 39.6952C53.6051 40.108 55.3133 41.0884 56.7627 42.4301C59.1956 44.8553 60.2308 48.3642 59.5061 51.6667Z"
            fill="#C3C3C3"
            stroke="#959595"
            strokeWidth="0.533333"
            strokeMiterlimit="10"
        />
        <path
            d="M49.5798 45C49.7094 45 49.879 45.026 50.0369 45.084C50.1772 45.1356 50.3495 45.2288 50.4578 45.3906L53.1267 48.2236C53.5388 48.6612 53.5386 49.408 53.1267 49.8457C52.7003 50.2984 51.9783 50.2828 51.5271 49.8574L51.5183 49.8496L51.7097 49.6631L51.5183 49.8486L50.7537 49.0625V53.0127C50.7537 53.6471 50.2551 54.2001 49.6199 54.2002C48.9845 54.2002 48.4851 53.6471 48.4851 53.0127V49.0625L47.7224 49.8447L47.7234 49.8457C47.2969 50.2985 46.575 50.2832 46.1238 49.8574L46.1179 49.8516L46.113 49.8457C45.8756 49.5936 45.7644 49.321 45.7644 49.0352C45.7644 48.9006 45.7893 48.7421 45.8464 48.5938C45.8971 48.4622 45.9826 48.3201 46.1179 48.2168L48.7947 45.377C48.8784 45.2881 49.0023 45.1985 49.1296 45.1309C49.253 45.0654 49.4172 45.0001 49.5798 45Z"
            fill="white"
            stroke="#959595"
            strokeWidth="0.533333"
        />
    </svg>
)

export default UploadCvIcon
